export default __webpack_public_path__ + "static/media/Ertiga_Fix.553b12c6.png";